module.exports = '/ng-templates/commons/components/kp-sdi-requests/kp-sdi-request-list-item.tpl.ftl';
